import req from './req'

// 按导购维度导出报表
export function exportStatistics (taskId, params) {
  return req.get('/salesperson/task/export-task/' + taskId, params)
}
